import React from 'react';

const bootstrap = global.bootstrap;

class CardInfoTooltip extends React.Component {
  constructor(props) {
    super(props);
    this.iconRef = React.createRef();
    this.tooltip = null;
  }

  componentDidMount() {
    if (this.iconRef.current && bootstrap) {
      this.tooltip = new bootstrap.Tooltip(this.iconRef.current, {
        placement: 'left',
        title: this.props.text,
        trigger: 'hover focus'
      });
    }
  }

  componentWillUnmount() {
    if (this.tooltip) {
      this.tooltip.dispose();
      this.tooltip = null;
    }
  }

  render() {
    return (
      <span
        className="card-info-tooltip"
        ref={this.iconRef}
        tabIndex={0}
        role="button"
        aria-label="More information"
      >
        i
      </span>
    );
  }
}

export default CardInfoTooltip;
